import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import FleetDetailScreen from './screens/FleetDetailScreen';
import FleetListScreen from './screens/FleetListScreen';
import EditFleetScreen from './screens/EditFleetScreen';
import EditFleetDriverScreen from './screens/EditFleetDriverScreen';

function FleetInfo(props) {
    const { isFleetInfo } = props;
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route path="" element={<FleetListScreen />} />
                    <Route path={"/add"} element={<EditFleetScreen />} />
                    <Route path={"/:agencyId/edit"} element={<EditFleetScreen />} />
                    <Route path={"/:agencyId/add"} element={<EditFleetDriverScreen />} />
                    <Route path="/:agencyId" element={<FleetDetailScreen isFleetInfo={isFleetInfo} />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default FleetInfo;
